import { Injectable } from '@angular/core';

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WindowReferenceService {

  constructor() { }

  get nativeWindow() {
    return getWindow();
  }

  get location(): Location {
    return getWindow().location;
  }

  reload(): void {
    getWindow().location.reload();
  }

  navigateTo(url: string): void {
    getWindow().location.href = url;
  }
}
